/* eslint-disable @typescript-eslint/no-unused-vars */
import { createModel } from '@wmfe/mach-pro-store';
import { View } from '@wmfe/mach-pro-components-react';
import { reportAdsApiEvent, reportHeaderDataError } from '@/src/pages/homepage/home_page_main/utils';
import { addDynamicTagProperty, handleFilterParams } from '@/src/common/utils/mainPageUtils';
import { HomePageLoganType, logan } from '@pages/homepage/home_page_main/utils/Logan';
import { reportRaptorMetrics } from '@common/SLRaptor';
import { cloneDeep } from 'lodash';
import { handleSecPicAPIData } from '@/src/pages/tool/sec_page_pic_cache';
import { handlePreviewParams } from '@/src/utils/preview';
import { initFilterDataSelectedStatusByOptions } from '@/src/sub_packages/filter_bar/utils';
import {
  URL, homeRequest, isNotServiceWithCode, isNuclearCode, isNonEmptyObject
} from '../utils/service';
import {
  AddressBarDefaultData,
  SearchBarDefaultData,
  AddressBarTempID,
  PreheatItemDefaultData,
  HomePageBgID,
  SearchBarTempID,
  HomePageBgDefaultData,
  FilterBarTempID,
  NoMoredataTempID,
  PreheatTempID,
  HomePageCardV2ID,
  HomePgaeFirstLoadingPageInfoData,
  HomePgaeFirstLoadingShopListData,
  FilterBarCommonTempID,
  SkeletonLoadingPageID,
  TopViewTempID,
  HeaderTitleID,
  PromotionBannerTempID,
  HOME_PAGE_ERROR_CODE,
  REFRESH_TYPE
} from '../utils/constant';
import { HomePageMonitor } from '../utils/monitor';
import {
  getAddressComponentInfo, getBannerComponentInfo, getFitRatio, getHeadBgComponentInfo, getSearchComponentInfo
} from '../utils/ui';
import { HomePageMetrics, MStepType } from '../utils/Metrics';

const SLCompass = Mach.requireModule('SLCompass');
const homePageMetrics = new HomePageMetrics([`SAILOR_HOME_PAGE_METRICS_CUSTOM_STEP_${SLCompass?.getActualCompassInfo?.()?.actualRegion || SLCompass?.getCompassInfo?.().region}`, 'SAILOR_HOME_PAGE_METRICS_CUSTOM_STEP_ALL'], ((Mach.env as any).pageInit || Date.now()));
// Horn开关控制是否请求首页头图接口
const Horn = Mach.requireModule('SLCHorn');
const hornConfig = Horn?.getAppConfig?.();

export interface GlobalState {
  // 是否显示加载状态
  showLoading: boolean;
  skeletonSwitch: boolean;
  // Feed页码数
  pageNo: number;
  // 是否有更多数据
  hasMoreData: boolean;
  // 二级页头图数据
  secPagePicData: any;
  // 运营区数据
  marketAPIData: any;
  // Feed流数据
  feedAPIData: any;
  // 追加Feed流数据
  loadMoreFeedAPIData: any;
  // 筛选栏数据
  filterPanelData: any;
  // 筛选栏标题数据
  filterCardTitleData: any;
  // 筛选条是否处于展开状态：展开后主列表会禁用滚动
  filterPanelExpanded: boolean;
  // 是否允许上拉加载,默认false,feed有数据时为true
  pullUpEnable: boolean;
  // 主包背景颜色
  backgroundColor: string;
  // 刷新来源 1代表筛选刷新 0是其他刷新
  refreshType: number;
  // 筛选栏数据
  filterOptions: any;
  loadMarketDataFinish: boolean;
  loadFeedDataFinish: boolean;
  // Feed去重标识
  bizTraceId: string;
  pageSource: string;
  fitRatio: any;
  isFeedSkeletonShow: boolean;
}

// Feed区接口请求中标识
globalThis.isLoadingFeedData = false;
// 运营接口请求中标识
globalThis.isLoadingMarketData = false;
// 页面上次请求完成时间戳
globalThis.lastFeedDataRequestTime = 0;
// 接口切换标识
globalThis.feedUseType = '';
// 开城预热倒计时定时器
globalThis.currentCountDownIntervalId = null;

globalThis.pageType = {
  feedType: 'null', marketType: 'null', feedLength: 0, hasMoreData: false
};

const createInitState = () => ({
  //页面来源：首页Feeds
  pageSource: 'HomePageFeeds',
  // 是否显示加载状态
  showLoading: true,
  // 骨架开关
  skeletonSwitch: true,
  // Feed页码数
  pageNo: 0,
  // 是否有更多数据
  hasMoreData: true,
  // 运营区数据
  marketAPIData: {
    [URL.PgaeInfo]: [HomePgaeFirstLoadingPageInfoData],
  },
  // Feed流数据
  feedAPIData: {
    [URL.ShopList]: [HomePgaeFirstLoadingShopListData],
  },
  loadMoreFeedAPIData: {},
  // 筛选栏吸顶状态
  filterPanelData: null,
  // 筛选栏标题数据 初始化为空，否则HeaderView会渲染多余节点最终导致多个筛选栏
  filterCardTitleData: null,
  // 筛选框是否展开
  filterPanelExpanded: false,
  // 是否允许上拉加载
  pullUpEnable: false,
  // 主包背景颜色
  backgroundColor: '#F5F6FA',
  // 刷新来源
  refreshType: REFRESH_TYPE.PULL_DOWN,
  // 当前筛选栏选中数据
  filterOptions: {},
  loadMarketDataFinish: false,
  loadFeedDataFinish: false,
  // Feed去重标识
  bizTraceId: '',
  // 顶通banner宽高适配比例
  fitRatio: null,
  isFeedSkeletonShow: false
} as GlobalState);

// 首页数据
export const global = createModel()({
  state: createInitState(),
  reducers: {
    handleShowLoading: (state, payload) => ({
      ...state,
      showLoading: payload
    }),
    handleMarketData: (state, payload) => ({
      ...state,
      ...payload,
    }),
    handleFeedListData: (state, payload) => {
      if (globalThis.triggerOnPullDownRefreshDataCheckTimer !== 0) {
        clearTimeout(globalThis.triggerOnPullDownRefreshDataCheckTimer);
        globalThis.triggerOnPullDownRefreshDataCheckTimer = 0;
      }
      return {
        ...state,
        ...payload,
      };
    },
    // 更新筛选栏数据
    updateFilterPanelData: (state, payload) => {
      const { filterPanelData } = state;
      return {
        ...state,
        filterPanelData: {
          ...filterPanelData,
          ...payload
        }
      };
    },
    // 更新筛选栏标题数据
    updateFilterCardTitleData: (state, payload) => ({
      ...state,
      filterCardTitleData: payload
    }),
    // 更新筛选面板展开状态
    handleFilterPanelExpanded: (state, payload) => {
      console.log('handleFilterPanelExpanded:', payload);
      return {
        ...state,
        filterPanelExpanded: payload
      };
    },
    // 背景颜色
    updateBackgroundColor: (state, payload) => ({
      ...state,
      backgroundColor: payload
    }),
    // 更改刷新类型
    updateRefreshType: (state, payload) => ({
      ...state,
      refreshType: payload
    }),
    handleResetState: () => createInitState(),
    handleFeedSkeletonData: (state, payload) => ({
      ...state,
      ...payload
    })
  },
  effects: (dispatch) => ({
    // Metrics 自定义测速， 可以 主子包传 MStepType.start MStepType.end测速
    homePageMetricsRecordStep: (payload) => {
      const { stepName, type, curTs } = payload || {};
      if (stepName) {
        homePageMetrics?.recordStep?.(stepName, type || MStepType.None, curTs);
      }
    },
    homePageMetricsReport: () => {
      homePageMetrics?.report?.();
    },
    /**
     * 二级页头图配置接口
     */
    fetchSecPagePicData: () => {
      if (!hornConfig?.openPicCache) {
        return;
      }
      const SLLocation = Mach.requireModule('SLLocation');
      const location = SLLocation?.getLocation();
      const params = {
        mainBundleVersion: Mach.env.bundleVersion,
        requestSource: 'MachPro', // 表示二期，native请求不传，表示一期
        location: {
          latitude: location?.latitude,
          longitude: location?.longitude,
          actualLatitude: location?.actualLatitude,
          actualLongitude: location?.actualLongitude,
        },
      };
      homeRequest(URL.SecPagePicList, params, {}, {}, false).then((response) => {
        globalThis.isLoadingSecPagePicData = false;
        handleSecPicAPIData(response);
      });
    },

    /**
         * 请求运营区和Feed流数据
         */
    fetchAllPageData: () => {
      const { fetchMarketData, fetchFeedListData } = dispatch.global;
      fetchMarketData({});
      fetchFeedListData({ pageNo: 0 });
    },
    /**
         * 请求运营区数据
         */
    fetchMarketData: (payload, { global: state }) => {
      const { fetchSecPagePicData } = dispatch.global;
      if (globalThis.isLoadingMarketData) {
        return;
      }
      globalThis.isLoadingMarketData = true;
      const SLLocation = Mach.requireModule('SLLocation');
      const location = SLLocation?.getLocation();

      //用户经纬度信息补偿上报
      const Statistics = Mach.requireModule('Statistics');
      Statistics.view('c_waimai_c_overseas_aatucy3n', 'b_sailor_c_07k6o565_mv', {});

      const params = {
        mainBundleVersion: Mach.env.bundleVersion,
        requestSource: 'MachPro', // 表示二期，native请求不传，表示一期
        location: {
          latitude: location?.latitude,
          longitude: location?.longitude,
          actualLatitude: location?.actualLatitude,
          actualLongitude: location?.actualLongitude,
        },
      };
      const { marketAPIData = [], skeletonSwitch } = state;
      const { showIndicator = true, onComplete } = payload || {};

      const url = URL.PgaeInfo;
      const { handleMarketData, homePageMetricsRecordStep } = dispatch.global;
      const startDuration = Date.now();
      if (typeof onComplete === 'function') {
        onComplete({ key: 'request-market-start', startDuration });
      }
      const homePageHeaderMoniter = new HomePageMonitor();
      globalThis.pageType.marketType = 'null';
      handlePreviewParams(params, url);
      homeRequest(url, params, {}, {}, showIndicator).then((response) => {
        if (typeof onComplete === 'function') {
          onComplete({ key: 'request-market-end', duration: `${Date.now() - startDuration}ms` });
        }
        const result = response || {};
        const { module_header = {} } = response;
        let resultType = 'unknown';
        const componentIds: string[] = [];
        if (!module_header) { // 无header数据
          const component_list = [HomePageBgDefaultData, AddressBarDefaultData, SearchBarDefaultData];
          const module_header = {
            component_list,
            layout_info: {}
          };
          result.module_header = module_header;
          resultType = 'empty';
        } else {
          // 运营区数据收集
          resultType = 'success';
          let { component_list = [] } = module_header;
          let hasHeaderBg = false;
          let hasAddressBar = false;
          let hasSearchBar = false;
          let hasPromotionBanner = false;
          // 天气氛围
          let hasTopView = false;
          let headerBgInfo;
          let addressInfo;
          let searchInfo;
          let bannerInfo;
          for (let index = 0; index < component_list.length; index++) {
            const element = component_list[index];
            if (element.component_id === HomePageBgID) {
              hasHeaderBg = true;
            } else if (element.component_id === AddressBarTempID) {
              hasAddressBar = true;
            } else if (element.component_id === SearchBarTempID) {
              hasSearchBar = true;
            } else if (element.component_id === PromotionBannerTempID) {
              hasPromotionBanner = true;
              // 缓存顶通宽高比
              handleMarketData({
                fitRatio: getFitRatio(element)
              });
            } else if (element?.component_id === TopViewTempID) {
              hasTopView = true;
              // 天气组件数据包装
              headerBgInfo = getHeadBgComponentInfo(element);
              addressInfo = getAddressComponentInfo(element);
              searchInfo = getSearchComponentInfo(element);
              bannerInfo = getBannerComponentInfo(element);
            }
          }
          if (hasTopView && component_list) {
            // 将topView组件数据过滤掉，替换为天气氛围组件数据
            const newList = component_list.filter((item) => item?.component_id !== TopViewTempID);
            component_list = newList;
            // 插入组件，顺序为bannerInfo、searchInfo、addressInfo、headerBgInfo
            if (bannerInfo) {
              hasPromotionBanner = true;
              // 缓存顶通宽高比
              handleMarketData({
                fitRatio: getFitRatio(bannerInfo)
              });
              component_list.unshift(bannerInfo);
            } else {
              handleMarketData({
                fitRatio: null
              });
            }
            if (searchInfo) {
              hasSearchBar = true;
              component_list.unshift(searchInfo);
            } else {
              reportHeaderDataError(hasTopView, 'noSearchInfo');
            }
            if (addressInfo) {
              hasAddressBar = true;
              component_list.unshift(addressInfo);
            } else {
              reportHeaderDataError(hasTopView, 'noAddressInfo');
            }
            if (headerBgInfo) {
              hasHeaderBg = true;
              component_list.unshift(headerBgInfo);
            } else {
              reportHeaderDataError(hasTopView, 'noHeaderBgInfo');
            }
          }

          const { fitRatio } = state;
          // 顶通banner适配数据监控
          reportRaptorMetrics({ HomePageHeaderBannerRatioDataStatus: 1 }, { fitRatio: fitRatio ? JSON.stringify(fitRatio) : 'null', bundleVersion: Mach.env?.bundleVersion });

          if (!hasHeaderBg) { // 接口没下发背景数据：本地插入一条
            const insertIndex = 0;
            component_list.splice(insertIndex, 0, HomePageBgDefaultData);
            console.log('====== 接口没下发背景数据：本地插入一条 =======');
            reportHeaderDataError(hasTopView, 'noHeaderBgInfo');
          }

          if (!hasAddressBar) { // 接口没下发地址栏数据：本地插入一条
            const insertIndex = 1;
            component_list.splice(insertIndex, 0, AddressBarDefaultData);
            console.log('====== 接口没下发地址栏数据：本地插入一条 =======');
            reportHeaderDataError(hasTopView, 'noAddressInfo');
          }

          if (!hasSearchBar) { // 接口没下搜索址栏数据：本地插入一条
            const insertIndex = 2;
            component_list.splice(insertIndex, 0, SearchBarDefaultData);
            console.log('====== 接口没下发搜索址栏数据：本地插入一条 =======');
            reportHeaderDataError(hasTopView, 'noSearchInfo');
          }

          if (!hasPromotionBanner) {
            // 清空顶通宽高比缓存
            handleMarketData({
              fitRatio: null
            });
          }
          module_header.component_list = component_list;
          result.module_header = module_header;
        }

        homePageMetricsRecordStep({ stepName: 'marketReload', type: MStepType.Start });
        globalThis.pageType.marketType = resultType;

        handleMarketData({
          marketAPIData: {
            [url]: [response],
          },
          loadMarketDataFinish: true,
        });

        // 运营区监控上报
        homePageHeaderMoniter.reportHeaderResponseDataAvailable(1, {
          resultType,
          code: 0,
        });
      }).catch((error) => {
        globalThis.pageType.marketType = 'error';

        if (typeof onComplete === 'function') {
          onComplete({ key: 'request-market-end-error', duration: `${Date.now() - startDuration}ms` });
        }

        const code = error?.data?.code || error.code || 0;
        const isNotInService = isNotServiceWithCode(code);
        globalThis.lastNuclearButtonOn = globalThis.isNuclearButtonOn;
        globalThis.isNuclearButtonOn = code === HOME_PAGE_ERROR_CODE.NUCLEAR_BUTTON;
        const marketDataArray = isNotInService ? [] : cloneDeep(marketAPIData[url]) || []; // 不在服务范围，不使用上次数据
        if (!marketDataArray.length) { // 接口请求失败，当前没有数据, 则尝试兜底，否则继续展示上次数据
          let apiData = error?.data?.data || {};
          if (typeof apiData !== 'object' || !Object.keys(apiData).length || (!apiData.module_body && !apiData.module_footer && !apiData.module_header)) {
            // 判断不在服务范围不展示搜索框
            const component_list = [HomePageBgDefaultData, AddressBarDefaultData];
            if (!isNotInService) { // 在服务范围才插入搜索框
              component_list.push(SearchBarDefaultData);
            }

            apiData = {
              module_header:
                            {
                              component_list,
                              layout_info: {}
                            }
            };
          }
          marketDataArray.push(apiData);
        }

        marketDataArray.forEach((item) => {
          item.module_header.component_list = item.module_header.component_list.filter((component) => component.component_id !== SkeletonLoadingPageID);
        });

        // console.log(' info接口请求失败:', marketDataArray);
        logan(HomePageLoganType.Main, { msg: 'info接口请求失败', code, error });
        homePageMetricsRecordStep({ stepName: 'marketReload', type: MStepType.Start });
        handleMarketData({
          marketAPIData: {
            [URL.PgaeInfo]: [...marketDataArray],
          },
          loadMarketDataFinish: true,
        });

        const resultType = 'error';
        homePageHeaderMoniter.reportHeaderResponseDataAvailable(1, {
          resultType,
          code,
        }, { code });
      }).finally(() => {
        globalThis.isLoadingMarketData = false;
        // 通知native做冷启动指标打点
        Mach.sendEvent('apiLoadFinish', { type: 'header' });
        setTimeout(() => {
          // 首页请求完成后再做二级页头图请求
          if (globalThis.shouldRequestSecPagePicData) {
            globalThis.shouldRequestSecPagePicData = false;
            fetchSecPagePicData({});
          }
        }, 2000);
      });
    },
    /**
         * 请求列表数据
         * @param payload
         * @param param1
         */
    fetchFeedListData: (payload, { global: state }: any) => {
      if (globalThis.isLoadingFeedData) {
        return;
      }
      globalThis.isLoadingFeedData = true;
      const {
        hasMoreData, filterCardTitleData, bizTraceId, filterOptions
      } = state;
      let { filterPanelData } = state;
      const {
        pageNo = 0, options = {}, refreshType = REFRESH_TYPE.PULL_DOWN, showIndicator = true, onComplete
      } = payload || {};
      const SLLocation = Mach.requireModule('SLLocation');
      const location = SLLocation?.getLocation();
      const requestSource = globalThis.feedUseType;
      const optionsKey = requestSource === 'v3' ? 'optionsV2' : 'options';
      // 清空的时候要filterPanelData还没更新，需要传空
      const isOptionsEmpty = Object.keys(options).length === 0;
      const extraMap = {
        ...handleFilterParams(isOptionsEmpty ? {} : filterPanelData),
        tab_key: '-999'
      };
      const params = {
        mainBundleVersion: Mach.env.bundleVersion,
        location: {
          latitude: location?.latitude,
          longitude: location?.longitude,
          actualLatitude: location?.actualLatitude,
          actualLongitude: location?.actualLongitude,
        },
        [optionsKey]: options,
        pageSource: 5,
        pageSize: 20,
        pageNo,
        bizTraceId: pageNo > 0 ? bizTraceId : '',
        requestSource,
        extraMap
      };
      const url = URL.ShopList;
      const { handleFeedListData, homePageMetricsRecordStep, setFeedSkeleton } = dispatch.global;

      const homePageMoniter = new HomePageMonitor();
      const NoResponseMessage = 'response data is null';
      const FilterRefreshFailedMessage = 'filter refresh failed';
      const startDuration = Date.now();
      if (typeof onComplete === 'function') {
        onComplete({ key: 'request-feed-start', startDuration });
      }
      globalThis.pageType.feedType = 'null';
      globalThis.pageType.hasMoreData = hasMoreData ? 1 : 0;
      globalThis.pageType.feedLength = 0;
      handlePreviewParams(params, url);

      // 在主包 filterBarPanelItemDidSelectedIntercept 事件中部分机型已完成骨架屏设置，此处为兜底
      if (pageNo === 0
        && [REFRESH_TYPE.CLICK_FILTERBAR, REFRESH_TYPE.CLICK_FILTERBAR_REFRESH_TAG].includes(refreshType)) {
        setFeedSkeleton();
      }

      homeRequest(url, params, {}, {}, showIndicator).then((response) => {
        if (typeof onComplete === 'function') {
          onComplete({ key: 'request-feed-end', duration: `${Date.now() - startDuration}ms` });
        }
        if (!response) { // code为0，但数据为空，直接走catch逻辑
          globalThis.pageType.feedType = 'error response null';
          homePageMoniter.reportPageRenderAvailable(
            0,
            {
              page: pageNo,
              errorComponentId: '',
              feedLengthError: '1',
              isLoadMore: pageNo > 0 ? '1' : '0',
              marketType: globalThis.pageType.marketType,
              feedType: globalThis.pageType.feedType,
              feedLength: globalThis.pageType.feedLength,
              hasMoreData: globalThis.pageType.hasMoreData
            }
          );
          throw new Error(NoResponseMessage);
        }

        globalThis.lastNuclearButtonOn = globalThis.isNuclearButtonOn;
        globalThis.isNuclearButtonOn = (response.module_body?.component_list || []).some((item) => item.component_id === PreheatTempID && item.json_data?.sceneCode === HOME_PAGE_ERROR_CODE.NUCLEAR_BUTTON);
        if (globalThis.isNuclearButtonOn && (pageNo > 0 || isNonEmptyObject(options))) {
          globalThis.isLoadingFeedData = false;
          //翻页刷新、筛排切换刷新Feed，此时触发核按钮，直接刷新整个首页。
          const EventCenter = Mach.requireModule('EventCenter');
          EventCenter?.emit('refresh_all_homepage', { type: 'nuclear', status: 'open' });
          return;
        }

        // 当前请求的Feed接口切换标识
        if (response?.module_header?.extra_data?.useType) {
          globalThis.feedUseType = response?.module_header?.extra_data?.useType;
        }

        // 获取列表分页数
        const pagination = response?.module_body?.module_data?.pagination;
        const { page_no, has_more_page } = pagination || {};
        const feedDataArray: any[] = [];
        feedDataArray.push(response);
        // 筛选栏数据
        const componentList = response?.module_header?.component_list || [];
        let currentFilterPanelData = componentList?.find((item) => (item.component_id === FilterBarTempID || item.component_id === FilterBarCommonTempID)) || null;
        let currentCardTitleData = componentList?.find(({ component_id }) => (component_id === HeaderTitleID)) || null;
        if (currentFilterPanelData && pageNo > 0) {
          const uuid = Mach.env.uuid || '';
          reportRaptorMetrics({ SLHomePageFilterBarRenderDataError: 1 }, { uuid: String(uuid), type: 'data' });
          logan(HomePageLoganType.Main, { msg: '筛选栏数据重复', currentFilterPanelData });
        }
        // 点击筛选栏保留已有筛选栏数据
        if (refreshType === REFRESH_TYPE.CLICK_FILTERBAR) {
          if (filterPanelData) {
            // 若服务端返回了数据则替换筛选栏数据, 否则添加已有筛选栏数据
            if (currentFilterPanelData) {
              const replaceIndex = componentList?.findIndex(
                (item) => (item.component_id === FilterBarTempID || item.component_id === FilterBarCommonTempID)
              );
              if (replaceIndex !== -1 && filterPanelData) {
                componentList.splice(replaceIndex, 1, filterPanelData);
              }
            } else {
              const index = componentList?.length || 0;
              componentList.splice(index, 0, filterPanelData);
            }
            currentFilterPanelData = filterPanelData;
          }
          if (filterCardTitleData) {
            if (currentCardTitleData) {
              const cardTitleIndex = componentList?.findIndex(({ component_id }) => (component_id === HeaderTitleID));
              if (cardTitleIndex !== -1 && filterCardTitleData) {
                componentList.splice(cardTitleIndex, 1, filterCardTitleData);
              }
            } else {
              // 现有需求，筛排上的标题一定是第一个
              componentList.unshift(filterCardTitleData);
            }
            currentCardTitleData = filterCardTitleData;
          }
        } else if (refreshType === REFRESH_TYPE.CLICK_FILTERBAR_REFRESH_TAG) {
          // 筛选栏刷新
          const replaceIndex = componentList?.findIndex(
            (item) => (item.component_id === FilterBarTempID || item.component_id === FilterBarCommonTempID)
          );
          if (replaceIndex !== -1) {
            currentFilterPanelData = initFilterDataSelectedStatusByOptions(currentFilterPanelData, options);
            currentFilterPanelData.json_data.refreshByFilterRefreshTag = true;
            componentList.splice(replaceIndex, 1, currentFilterPanelData);
            homePageMoniter.reportFilterRefreshStatus(1);
          } else {
            // 筛排刷新异常
            homePageMoniter.reportFilterRefreshStatus(0);
            throw new Error(FilterRefreshFailedMessage);
          }
        }
        // 重新赋值module_header
        response.module_header = {
          ...response.module_header,
          component_list: componentList,
        };

        console.log('has_more_page ?? hasMoreData:', has_more_page ?? hasMoreData, has_more_page);
        let hasPreheat = false;
        let sceneCode = -9999;
        if (!has_more_page) { // 没有更多数据。插入无更多数据item
          const { module_body, module_header } = response;

          // 判断是否有预热模版，有则无需展示无更多数据
          if (module_header) {
            const headerComponentList = module_header.component_list || [];
            for (let index = 0; index < headerComponentList.length; index++) {
              const element = headerComponentList[index];
              if (element.component_id === PreheatTempID) {
                hasPreheat = true;
                break;
              }
            }
          }
          if (module_body) {
            const headerComponentList = module_body.component_list || [];
            for (let index = 0; index < headerComponentList.length; index++) {
              const element = headerComponentList[index];
              if (element.component_id === PreheatTempID) {
                hasPreheat = true;
                sceneCode = element?.json_data?.sceneCode;
                // 兜底code状态
                homePageMoniter?.reportHomePagePreheatCode(element?.json_data?.sceneCode, {});
                break;
              }
            }
          }
          if (!hasPreheat) {
            const { component_list = [] } = module_body;
            const noMoreDataItem = {
              component_id: NoMoredataTempID,
              component_properties: {
                render_type: 'custom'
              },
              layout_info: {},
              json_data: {}
            };
            component_list.push(noMoreDataItem);
            console.log('====== 本地插入无更多数据 =======');
          }
        }

        // 上拉加载时，复用之前的筛选栏数据
        if (pageNo > 0) {
          currentFilterPanelData = filterPanelData;
          currentCardTitleData = filterCardTitleData;
        }
        // Feed去重标识
        const bizTraceId = response?.module_body?.extra_data?.bizTraceId || '';
        // 计算卡片的动态标签属性
        const dynamicTagCalcuateStart = Date.now();
        response = addDynamicTagProperty(response);
        const dynamicTagCalcuateCost = Date.now() - dynamicTagCalcuateStart;
        logan(HomePageLoganType.Main, { msg: '动态标签属性计算耗时', cost: dynamicTagCalcuateCost });
        dispatch.filterBarHandleModel.updateFilterBarHandlePanelData(currentFilterPanelData);

        const handleFeedApiData = {
          [url]: [...feedDataArray],
        };
        const feedData = pageNo === 0
          ? { feedAPIData: handleFeedApiData, loadMoreFeedAPIData: {} }
          : { loadMoreFeedAPIData: { data: handleFeedApiData } };

        globalThis.refreshFeedDataTimeStart = Date.now();
        homePageMetricsRecordStep({ stepName: 'feedReload', type: MStepType.Start });
        globalThis.pageType.feedType = hasPreheat ? 'preheat' : 'success';
        globalThis.pageType.feedLength = response?.module_body?.component_list?.length;
        handleFeedListData({
          ...feedData,
          showLoading: false,
          pageNo: page_no ?? pageNo,
          hasMoreData: Boolean(has_more_page),
          pullUpEnable: Boolean(has_more_page),
          filterPanelData: currentFilterPanelData,
          filterCardTitleData: currentCardTitleData,
          backgroundColor: '#F7F7F7', // 显示错误页时会修改背景颜色，网络请求成功后重置回来
          refreshType,
          filterOptions: {
            ...options,
            filterRefreshTag: 0 // 去除filterRefreshTag不做缓存
          },
          loadFeedDataFinish: true,
          bizTraceId,
          skeletonSwitch: !hasPreheat,
          isFeedSkeletonShow: false
        });

        reportAdsApiEvent(response?.module_body?.component_list || []);
        //上报Feed 商卡数据有效性
        let feedLength = 0;
        let resultType = 'unknown';
        const componentIds: string[] = [];

        if (!hasPreheat) {
          //非开城，Feed长度
          if (response?.module_body?.component_list) {
            feedLength = response?.module_body?.component_list?.length;
            response?.module_body?.component_list?.forEach((item) => {
              if (!componentIds.includes(item.component_id)) {
                componentIds.push(item.component_id);
              }
            });
            if (feedLength > 0) {
              resultType = 'success';
            } else {
              resultType = 'empty';
            }
          } else {
            // 兼容component_list为null时的打点上报
            resultType = 'empty';
            feedLength = 0;
          }
        } else {
          resultType = 'preheat';
        }
        // 请求成功，检测是否有商卡数据
        if (pageNo === 0) {
          homePageMoniter.reportFeedResponseDataAvailable(1, bizTraceId, {
            resultType,
            hasMoreData: hasMoreData ? 1 : 0,
            feedLength,
            code: sceneCode,
            feedLengthError: feedLength <= 5 ? '1' : '0'
          }, { components: componentIds });
        }
      }).catch((error) => {
        globalThis.pageType.feedType = 'error';
        if (typeof onComplete === 'function') {
          onComplete({ key: 'request-feed-end-error', duration: `${Date.now() - startDuration}ms` });
        }

        // 请求失败，上报端侧监控
        if (pageNo === 0) {
          homePageMoniter.reportFeedResponseDataAvailable(1, bizTraceId, {
            resultType: 'error',
            hasMoreData: false,
            feedLength: 0,
            code: error?.data?.code || error.code || -999,
            feedLengthError: '1'
          });
        }

        const code = error?.data?.code || error.code || 0;

        /// 请求失败。需要加入兜底样式（核按钮除外）
        if (pageNo !== 0 && !isNuclearCode(code)) {
          // 错误提示
          const Toast = Mach.requireModule('Toast');
          const tips = globalThis.__i18nMain__.getText('shouye_default_4') || 'Something went wrong! Please try again.';
          Toast.show(tips, 2);
          // 下拉加载更多时发生错误，直接展示当前数据，不刷新列表
          handleFeedListData({
            showLoading: false,
          });
          homePageMoniter.reportPageRenderAvailable(
            0,
            {
              page: pageNo,
              errorComponentId: '',
              feedLengthError: '1',
              isLoadMore: pageNo > 0 ? '1' : '0',
              marketType: globalThis.pageType.marketType,
              feedType: globalThis.pageType.feedType,
              feedLength: globalThis.pageType.feedLength,
              hasMoreData: globalThis.pageType.hasMoreData
            }
          );
          return;
        }

        const isNotInService = isNotServiceWithCode(code);
        let apiData = error?.data?.data || {};
        if ((typeof apiData !== 'object' || !Object.keys(apiData).length) && !isNotInService) {
          const errorCode = error?.data?.code || error?.code || error?.error?.code || 0;
          const errorMessage = error?.data?.msg || error?.msg || error?.error?.message || ''; // 尝试从接口获取错误码和提示信息
          const defaultData = PreheatItemDefaultData;
          defaultData.json_data.sceneCode = errorCode;
          defaultData.json_data.message = errorMessage;
          const component_list = [defaultData];
          // console.log('====== 接口没下发无数据样式：本地插入一条 =======', error, component_list);

          // 筛排刷新异常会导致数据无法正确对应，需要基于旧筛排回滚选中状态
          if (refreshType === REFRESH_TYPE.CLICK_FILTERBAR_REFRESH_TAG) {
            logan(HomePageLoganType.Feed, {
              msg: 'filterRefreshInit from catch',
              data: filterPanelData
            });
            filterPanelData = initFilterDataSelectedStatusByOptions(filterPanelData, filterOptions);
            // TODO 常规浏览此处filterPanelData.json_data一定有值，初始化报错原因需要进一步确认
            if (filterPanelData?.json_data) {
              filterPanelData.json_data.refreshByFilterRefreshTag = true;
              dispatch.filterBarHandleModel.updateFilterBarHandlePanelData(filterPanelData);
            }
          }

          apiData = {
            module_header: {
              component_list: [
                filterCardTitleData,
                filterPanelData
              ].filter(Boolean) // 滤除无效节点，防止影响渲染
            },
            module_body: {
              component_list,
            }
          };
        }
        const feedDataArray = [apiData];
        globalThis.refreshFeedDataTimeStart = Date.now();
        homePageMetricsRecordStep({ stepName: 'feedReload', type: MStepType.Start });
        handleFeedListData({
          showLoading: false,
          feedAPIData: {
            [URL.ShopList]: [...feedDataArray],
          },
          loadFeedDataFinish: true,
          hasMoreData: false,
          pullUpEnable: false,
          // 保留本次回退筛排改动
          filterPanelData,
          isFeedSkeletonShow: false
        });
      }).finally(() => {
        globalThis.isLoadingFeedData = false;
        // 通知native做冷启动指标打点
        Mach.sendEvent('apiLoadFinish', { type: 'shop' });
        /// 存储第一页请求完成时间
        if (pageNo === 0) {
          // 判断View.refresh是否存在
          if (Mach.env.isDebug && !View.refresh) {
            const Toast = Mach.requireModule('Toast');
            Toast.show('====== 发生异常，请联系首页开发RD！！！ =======', 2);
          }
          View.refresh?.();
          globalThis.lastFeedDataRequestTime = Math.floor(Date.now() / 1000);
        }
      });
    },
    resetState: () => {
      const { handleResetState } = dispatch.global;
      handleResetState();
    },
    setFeedSkeleton: () => {
      const { handleFeedSkeletonData } = dispatch.global;
      handleFeedSkeletonData({
        isFeedSkeletonShow: true,
      });
    }
  })
});
